import { render } from "./DashboardUploadCard.vue?vue&type=template&id=e08c561e"
import script from "./DashboardUploadCard.vue?vue&type=script&lang=js"
export * from "./DashboardUploadCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__